const CLOUDINARY_STYLE_ID = 'cloudinary-video-player-style';
const CLOUDINARY_STYLE_HREF = '/static/styles/vendor/cloudinary-video-player/dist/cld-video-player.min.css';

export default function loadCloudinaryPlayerStyles() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(CLOUDINARY_STYLE_ID)) {
    return;
  }

  const hasCloudinaryStyleLink = Array.from(document.querySelectorAll('link')).some((link) => {
    const href = link.getAttribute('href');
    return href === CLOUDINARY_STYLE_HREF || link.href.endsWith(CLOUDINARY_STYLE_HREF);
  });

  if (hasCloudinaryStyleLink) {
    return;
  }

  const link = document.createElement('link');
  link.id = CLOUDINARY_STYLE_ID;
  link.rel = 'stylesheet';
  link.href = CLOUDINARY_STYLE_HREF;
  document.head.appendChild(link);
}